import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator,
    Platform,
    KeyboardAvoidingView,
    TouchableOpacity,
    Alert,
    BackHandler,
    Image,
    ScrollView,
    RefreshControl, I18nManager
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";

import Colors, {colorDark, colorPrimary} from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
//import HMImageBackground from "../../../../customviews/HMImageBackground";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import {
    serviceActionListFilter,
    serviceActionError
} from "./action/ActionListMicroConsumptionSatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";

//import Modal from "react-native-modal";
//import ParentScreen from "../../../../ParentScreen";

import * as NavigationService from "../../../../redux/NavigationService";
import {Tools} from "../../../../tools/Tools";
//import HMDialogSelectDate from "../../../../customviews/HMDialogSelectDate";
// import moment from "moment-jalaali";
// import fa from "moment/src/locale/fa";
import HMButton from "../../../../customviews/HMButton";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMIcon from "../../../../customviews/HMIcon";
import HMModal from "../../../../customviews/modal/HMModal";
import HMDialogSelectDate from "../../../../customviews/HMDialogSelectDate";


// moment.locale("fa");
// moment.loadPersian();
let container = null;
export default class ListMicroConsumptionSatiaScreen extends Component {
    constructor(props) {
        super(props);
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        // let endDate = moment().format('jYYYY/jM/jD');
        //
        // let m = moment(endDate, 'jYYYY/jM/jD');
        //
        // let beginDate = m.subtract(1, 'month').locale('fa').format('jYYYY/jM/jD');
        this.state = {
            showCommunications: false,
            OneDate: true,
            typeNoRefreshScreen: null,
            indexSelectCredit: 0,
            DateFrom: "",
            DateTo: "",


            // DateFrom: beginDate,
            // DateTo: endDate,
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null,
            showModal: false,
            Filter: [],
            indexSelectType: 0

        };
        container = this;

        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)
        this.props.navigation.addListener('focus', () => {
                /*   store.dispatch(serviceActionListFilter([]))
                   props.callserviceActionRefresh();
                   this.getData(1)*/
            }
        )
        this.props.navigation.addListener('blur', () => {})

    }

    state = {
        show: false
    };

    componentWillReceiveProps(props) {
        if (props.response && props.response.status === false) {

            this.setState({
                typeNoRefreshScreen: true
            })
        }

        if (props.resultsAll && props.resultsAll.credit && props.resultsAll.credit.length > 0 && this.state.OneDate) {
            this.setState({
                OneDate: false,
                DateFrom: props.resultsAll.credit[0].BEGINDATE,
                DateTo: props.resultsAll.credit[0].ENDDATE,

            })


        }
    }

    async componentDidMount() {
        //   BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);

    }

    componentWillUnmount() {
        this.props.callserviceActionRefresh();
        this.props.callserviceActionListCredits();

    }

    handleBackPress = () => {
        this.goBack(); // works best when the goBack is async
        return true;
    }

    goBack() {
        if (!this.state.showModal) {

            this.setState({
                    listMenu: []
                },
                () => {

                }
            )


        } else {
            NavigationService.Pop();
        }
    }

    getData(page, type, func) {
        // this.props.callserviceActionRefresh();
        //if (type)
        this.setState({typeNoRefreshScreen: type},
            () => {

            }
        );

        let paramss = {
            "beginDate": this.state.DateFrom,
            "endDate": this.state.DateTo,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,
            "page": page,

        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.props.callService(typeExport._baseUrlSatia + "ibs/getConnectionLogs", paramss, typeExport.TypeGetListMicroConsumptionSatiaScreen, typeExport._POST, page, typeExport._Count, null, func)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMicroConsumptionSatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListMicroConsumptionSatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    render() {
        let {item, myService} = this.props.route.params
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;


        let SERVICES = this.state.typeNoRefreshScreen ? (this.props.Credits && this.props.Credits[this.state.indexSelectCredit] && this.props.Credits[this.state.indexSelectCredit].SERVICES ? this.props.Credits[this.state.indexSelectCredit].SERVICES : []) : (this.props.resultsAll && this.props.resultsAll.credit && this.props.resultsAll.credit[0] ? this.props.resultsAll.credit[0].SERVICES : []);
        let Category = this.props.resultsAll && this.props.resultsAll.services ? [{
            CREDITUSED: 0,
            FNAME: "همه",
            IN: 0,
            NAME: "ALL",
            OUT: 0,
            URL: "",
            ALL: true,
        }, ...this.props.resultsAll.services] : [];
        let Credits = this.state.indexSelectType && this.state.indexSelectType != 0 ? this.state.Filter : this.props.results;

        // let Credits =this.props.resultsAll && this.props.resultsAll.credit && this.props.resultsAll.credit[this.state.indexSelectCredit] && this.props.resultsAll.credit[this.state.indexSelectCredit].SERVICES ? this.props.resultsAll.credit[this.state.indexSelectCredit].SERVICES : []

        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>

{/*

                <HMImageBackground

                />
*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1}}>
                            <HMActionBarSatia
                                menu
                                back

                                props={this.props} statusBarTransparent
                                // text={i18n.t('ListMicroConsumptionSatia.title')}
                                text={(item.name ? item.name : (item.title ? item.title : ''))}
                                //text={(data.name ? data.name : (data.title ? data.title : ''))}
                                //  text={this.state.arraySelected.length}


                                //  text={i18n.t('constant.Information')}

                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}
                                LeftView={
                                    <TouchableOpacity
                                        style={{

                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(24),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}

                                        onPress={

                                            //  onBackPress
                                            () => {
                                                this.setState({
                                                    showModal: true,
                                                    typeModal: "help"
                                                })
                                            }
                                        }>
                                        <HMIcon name={"ios-help-circle-outline"}
                                              style={{fontSize: moderateScale(26), color: Colors.light}}/>
                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </TouchableOpacity>
                                }

                            />

                            <ScrollView
                                refreshControl={
                                    <RefreshControl refreshing={this.props.isLoading}
                                                    onRefresh={() => {
                                                        if (!this.state.selectDate) {
                                                            store.dispatch(serviceActionListFilter([]));
                                                            this.props.callserviceActionRefresh();
                                                            this.setState({
                                                                    indexSelectCredit: 0,
                                                                    DateFrom: "",
                                                                    DateTo: "",
                                                                    OneDate: true,

                                                                },
                                                                () => {
                                                                    this.getData(1)
                                                                }
                                                            )
                                                        }
                                                        else
                                                            this.getData(1)


                                                    }
                                                    }/>
                                }
                            >
                                <View style={{flex: 1}}>


                                    <HMTextView
                                        cammas
                                         numberOfLines={2}
                                        type={"bold"}
                                        text={"گزارش مصرف ماهیانه"}
                                        styleRoot={{alignSelf: "center",}}
                                        style={{
                                            fontSize: moderateScale(14),
                                            marginTop: moderateScale(8),

                                            color: Colors.blackLight,
                                            //marginHorizontal: moderateScale(2),
                                            //  marginTop: moderateScale(4),
                                            textAlign: "center",


                                        }}/>
                                    <View
                                        style={{
                                            width: '98%',
                                            // height: moderateScale(30),
                                            // flexDirection:'row',
                                            borderRadius: moderateScale(4),

                                            backgroundColor: Colors.colorSecondPrimary,
                                            marginBottom: moderateScale(4),
                                            alignSelf: 'center',
                                            padding: moderateScale(2)
                                        }}>

                                        <View
                                            style={{
                                                width: '100%',
                                                flexDirection: 'row',
                                                marginVertical: moderateScale(2),
                                                // backgroundColor: Colors.colorRow,
                                                // alignSelf: 'center'
                                                // marginVertical:moderateScale(6),
                                            }}>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.setState({
                                                        showDialogDate: true
                                                    })
                                                }}
                                                style={{
                                                    flex: .33,
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginVertical: moderateScale(1),
                                                    backgroundColor: Colors.white,
                                                    borderRadius: moderateScale(8),
                                                    paddingVertical: moderateScale(2),

                                                }}>

                                                <TouchableOpacity
                                                    onPress={() => {
                                                        this.setState({
                                                            showDialogDate: true
                                                        })
                                                    }}
                                                    style={{
                                                        //   position: 'absolute',
                                                        //  bottom: 0,
                                                        overflow: 'hidden',
                                                        //  width: moderateScale(30),
                                                        // height: moderateScale(30),
                                                        borderRadius: moderateScale(15),
                                                        // padding: moderateScale(4),
                                                        margin: moderateScale(5),
                                                        backgroundColor: Colors.white,
                                                        alignItems: 'center',
                                                        justifyContent: "center"
                                                    }}>
                                                    <HMIcon
                                                        type={"FontAwesome"}
                                                        name="calendar" style={{
                                                        color: Colors.colorPrimary,
                                                        fontSize: moderateScale(16),
                                                        padding: moderateScale(4),
                                                        alignSelf: "center",
                                                    }}/>
                                                    <HMIcon type={"FontAwesome"}
                                                        name={"refresh"} style={{
                                                        position: 'absolute',
                                                        bottom: moderateScale(2),
                                                        right: moderateScale(2),
                                                        color: Colors.colorSecondPrimary,
                                                        fontSize: moderateScale(11),
                                                        padding: moderateScale(1),
                                                        //alignSelf: "center",
                                                    }}/>
                                                </TouchableOpacity>

                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"انتخاب زمان"}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        marginVertical: moderateScale(1),

                                                        color: Colors.colorPrimary
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "right",
                                                    }}/>
                                            </TouchableOpacity>

                                            <View style={{
                                                flex: .22,
                                                //  flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"ترافیک مصرفی"}
                                                    style={{
                                                        fontSize: moderateScale(11),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",

                                                    }}/>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={" (GB) "}
                                                    style={{
                                                        fontSize: moderateScale(9),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",

                                                    }}/>
                                            </View>
                                            <View style={{
                                                flex: .22,
                                                // flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={" تخفیف"}
                                                    style={{
                                                        fontSize: moderateScale(11),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",

                                                    }}/>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={" (GB) "}
                                                    style={{
                                                        fontSize: moderateScale(9),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",

                                                    }}/>
                                            </View>

                                            <View style={{
                                                flex: .22,
                                                // flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"اعتبار کسر شده"}
                                                    style={{
                                                        fontSize: moderateScale(11),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",
                                                    }}/>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={" (GB) "}
                                                    style={{
                                                        fontSize: moderateScale(9),

                                                        color: Colors.white,
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",
                                                    }}/>
                                            </View>


                                        </View>

                                        <FlatList
                                            data={(this.props.resultsAll && this.props.resultsAll.credit) || (this.state.typeNoRefreshScreen) ? (this.state.typeNoRefreshScreen ? this.props.Credits : this.props.resultsAll.credit) : []}

                                            style={{
                                                width: "100%",

                                                // alignSelf: 'center',
                                            }}
                                            renderItem={({item, index}) => {
                                                let checkUrl = item.URL && item.URL.length > 0;
                                                let url = item.URL && item.URL.length > 0 ? item.URL : null;
                                                let Consumption = Tools.convertByte(item.IN + item.OUT, "return", "G");
                                                let Deducted = Tools.getSizeMG(item.CREDITUSED, null, myService);
                                                return <View

                                                    style={{
                                                        width: "100%",

                                                        //  width: '100%',
                                                        //  flex:1,
                                                        // height: typeExport.WIDTH / 3,
                                                        marginBottom: moderateScale(1),
                                                        borderRadius: moderateScale(6),
                                                        //  borderColor: '#d0d8df',
                                                        // backgroundColor: Colors.white,
                                                        //  borderWidth: moderateScale(1),
                                                        overflow: 'hidden',
                                                        //  marginVertical: moderateScale(2),
                                                        // padding: moderateScale(6)
                                                    }}>

                                                    <View style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        marginVertical: moderateScale(1)
                                                    }}>

                                                        <TouchableOpacity
                                                            onPress={() => {

                                                                if (index !== this.state.indexSelectCredit)
                                                                    this.setState({
                                                                            itemSelectCredit: item,
                                                                            indexSelectCredit: index,
                                                                            DateFrom: item.BEGINDATE,
                                                                            DateTo: item.ENDDATE,
                                                                            typeNoRefreshScreen: true,
                                                                            showCommunications: false,

                                                                            // showModal: true
                                                                        },

                                                                        () => {
                                                                            //    this.getData(1, true)
                                                                        }
                                                                    )
                                                                //     Tools.GoLink(url)
                                                                //NavigationService.navigateParams("WebViewScreen", {item: {external_url: "https://icip.ito.gov.ir/index.php/site/page/view/list_ip",name:item.FNAME}})
                                                            }}
                                                            // disabled={!checkUrl}
                                                            style={{
                                                                flex: .33,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                paddingVertical: moderateScale(2),
                                                                backgroundColor: this.state.indexSelectCredit === index ? Colors.colorPrimary : !this.state.indexSelectCredit && index == 0 ? Colors.colorPrimary : Colors.white,
                                                                borderRadius: moderateScale(8)
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={this.state.selectDate ? (this.state.DateFrom ? this.state.DateFrom : " - ") + " تا " + (this.state.DateTo ? this.state.DateTo : " - ") : item.MONTH}
                                                                style={[{
                                                                    fontSize: moderateScale(this.state.selectDate ? 11 : 13),

                                                                    color: this.state.indexSelectCredit === index ? Colors.white : ((!this.state.indexSelectCredit && index == 0) ? Colors.white : Colors.blue),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                    //   textAlign: "center",
                                                                    marginVertical: moderateScale(1),
                                                                    //marginHorizontal: moderateScale(4),

                                                                }, 1 === 2 ? {
                                                                    textDecorationLine: "underline",
                                                                    textDecorationStyle: "solid",
                                                                    // textDecorationColor: "#000"
                                                                } : {}]}/>

                                                        </TouchableOpacity>


                                                        <View style={{
                                                            flex: .22,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',

                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={Consumption}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.white,
                                                                    //marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",


                                                                }}/>

                                                        </View>
                                                        <View style={{
                                                            flex: .22,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',

                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={(Consumption - Deducted).toFixed(Tools.getToFixed((Consumption - Deducted)))}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.white,
                                                                    //marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",


                                                                }}/>

                                                        </View>

                                                        <View style={{
                                                            flex: .22,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                cammas
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={Tools.getSizeMG(item.CREDITUSED, null, myService)}
                                                                style={{
                                                                    fontSize: moderateScale(14),

                                                                    color: Colors.white,
                                                                    //  marginHorizontal: moderateScale(2),
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                        </View>


                                                    </View>


                                                </View>
                                            }}

                                            keyExtractor={(item, index) => index.toString()}
                                            ListEmptyComponent={() =>
                                                null}
                                            // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                            ListFooterComponent={this.renderFooterCredit.bind(this)}
                                            // refreshing={this.props.showRefresh}
                                            // onRefresh={this.handleRefresh.bind(this)}
                                            //onEndReached={this.handleLoadMore.bind(this)}
                                            // initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                        />
                                        {/*    <View
                                            style={{
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>


                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"گزارش مصرف ترافیک " + "از " + (this.state.DateFrom ? this.state.DateFrom : " - ") + " تا " + (this.state.DateTo ? this.state.DateTo : " - ")}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(11)

                                                }}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.setState({
                                                        showDialogDate: true
                                                    })
                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.colorPrimary,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(6),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    //text={i18n.t('constant.Update')}
                                                    text={"تغییر تاریخ"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>
                                        </View>

                                        <View
                                            style={{
                                            width: '100%',
                                            flexDirection: "row",
                                            justifyContent: 'space-between',
                                            alignSelf: 'center',
                                            paddingHorizontal: moderateScale(6)
                                        }}>

                                            <View style={{
                                                flex: .5,
                                                //  width: '100%',
                                                flexDirection: "row",
                                                // justifyContent: 'space-between',
                                                alignItems: 'center',

                                                alignSelf: 'center',
                                                paddingHorizontal: moderateScale(6)
                                            }}>
                                                <View>
                                                    <HMIcon name={"cloud-download"} style={{
                                                        fontSize: moderateScale(15),
                                                        color: Colors.white,
                                                        marginHorizontal: moderateScale(6),
                                                        // marginTop: moderateScale(3)
                                                    }}/>
                                                    <HMIcon name={"cloud-upload"} style={{
                                                        fontSize: moderateScale(15),
                                                        color: Colors.white,
                                                        marginHorizontal: moderateScale(6),
                                                        // marginTop: moderateScale(3)
                                                    }}/>
                                                </View>

                                                <View>
                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        //text={i18n.t('constant.Update')}
                                                        text={"ترافیک مصرفی"}
                                                        type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(10),
                                                            // marginVertical: moderateScale(2),
                                                            //     marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>


                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        //text={i18n.t('constant.Update')}
                                                        text={this.props.resultsAll && this.props.resultsAll.credit ? Tools.convertByte((this.props.resultsAll.credit.IN + this.props.resultsAll.credit.OUT), "return") : 0}
                                                        type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(10),
                                                            //  marginVertical: moderateScale(2),
                                                            //     marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </View>

                                            </View>
                                            <View style={{
                                                flex: .5,
                                                //   width: '100%',
                                                flexDirection: "row",
                                                //  justifyContent: 'space-between',
                                                alignItems: 'center',
                                                alignSelf: 'center',
                                                paddingHorizontal: moderateScale(6)
                                            }}>
                                                <HMIcon name={"ios-trending-down"} style={{
                                                    fontSize: moderateScale(30),
                                                    color: Colors.white,
                                                    marginHorizontal: moderateScale(6),
                                                    // marginTop: moderateScale(3)
                                                }}/>
                                                <View>
                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        //text={i18n.t('constant.Update')}
                                                        text={"اعتبار مصرفی بین الملل"}
                                                        type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(10),
                                                            //  marginVertical: moderateScale(2),
                                                            //     marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>


                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        //text={i18n.t('constant.Update')}
                                                        text={this.props.resultsAll && this.props.resultsAll.credit ? Tools.getSizeMG(this.props.resultsAll.credit.CREDITUSED) : 0}
                                                        type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(10),
                                                            //  marginVertical: moderateScale(2),
                                                            //     marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </View>

                                            </View>

                                        </View>*/}


                                    </View>
                                    {/*    <TouchableOpacity
                                        style={{flexDirection: 'row', alignSelf: 'center'}}
                                        onPress={() => {
                                            NavigationService.navigateParams("ChartSatiaScreen", {
                                                itemAll: this.props.resultsAll,
                                                item: this.props.Credits,
                                                type: "GroupBarChart"
                                            })
                                        }}
                                    >
                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={"نمودار"}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: Colors.blue,
                                                fontSize: moderateScale(14),
                                            }}/>
                                        <HMIcon
                                            name={I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                            style={{
                                                color: Colors.blue,
                                                fontSize: moderateScale(14),
                                                //  padding: moderateScale(4),
                                                alignSelf: "center",
                                                marginHorizontal: moderateScale(4)
                                            }}/>
                                    </TouchableOpacity>*/}


                                    {/*     <View
                                style={{
                                    height: moderateScale(42),
                                    backgroundColor: Colors.colorPrimary,
                                    flexDirection: 'row',
                                    marginHorizontal: moderateScale(10),
                                    marginTop: moderateScale(6),
                                    borderRadius: moderateScale(14),
                                    borderColor: Colors.colorDark,
                                    borderWidth: moderateScale(1),
                                    //  marginBottom: moderateScale(10)
                                    // width:'100%'
                                }}>

                                <View
                                    style={{
                                        flex: .8,
                                        height: moderateScale(40),
                                        backgroundColor: Colors.white,
                                        borderRadius: moderateScale(14),
                                        flexDirection: 'row',
                                        paddingHorizontal: moderateScale(4),
                                        alignItems: 'center',

                                    }}>

                                    <View style={{width: moderateScale(5)}}/>

                                    <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                        <HMTextInput value={this.state.trackingCode}
                                                     onChangeText={(text) => this.setState({trackingCode: text}, () => {
                                                         //  this.getJsonMap()

                                                     })}
                                                     _height={40}
                                            //  autoFocus
                                            //  placeholder={i18n.t('constant.filter')}
                                                     placeholder={i18n.t('constant.TrackingCode')}
                                                     NoShowPlaceholder
                                            //باتد_width={'80%'}
                                            // icon={"md-person"}
                                                     style={{
                                                         fontSize: moderateScale(11),

                                                         // marginTop: moderateScale(6)
                                                     }} underlineColorAndroid="transparent"/>
                                    </View>

                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.getData(1)
                                        //  this.nextScreen(item, type)
                                    }}
                                    style={{
                                        flex: .2,
                                        height: moderateScale(32),
                                        backgroundColor: Colors.colorPrimary,
                                        borderTopEndRadius: moderateScale(14),
                                        borderBottomEndRadius: moderateScale(14),
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView
                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                        text={i18n.t('constant.Search')}
                                        type={"bold"}
                                        style={{
                                            textAlign: "center",
                                            color: Colors.white,
                                            fontSize: moderateScale(11)

                                        }}/>
                                </TouchableOpacity>

                            </View>*/}

                                    {
                                        SERVICES && SERVICES.length > 0 ?
                                            <View style={{width:'100%'}}>
                                                <HMTextView
                                                    cammas
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"گزارش نوع مصرف"}
                                                    styleRoot={{alignSelf: "center",}}
                                                    style={{
                                                        fontSize: moderateScale(14),
                                                        marginTop: moderateScale(8),

                                                        color: Colors.blackLight,
                                                        //marginHorizontal: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",


                                                    }}/>
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.colorRow,
                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>
                                                    <View style={{
                                                        flex: .4,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(2)
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"نام سرویس"}
                                                            style={{
                                                                fontSize: moderateScale(12),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>

                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"ترافیک مصرفی (GB)"}
                                                            style={{
                                                                fontSize: moderateScale(12),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",

                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"تخفیف (GB)"}
                                                            style={{
                                                                fontSize: moderateScale(12),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"اعتبار کسرشده (GB)"}
                                                            style={{
                                                                fontSize: moderateScale(12),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>


                                                </View>
                                                <View style={{
                                                    width: '99%',
                                                    height: moderateScale(1),
                                                    alignSelf: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                            </View>
                                            :
                                            null
                                    }


                                    {/*<EmptyView empty={this.props.empty}/>*/}


                                    <FlatList
                                        data={SERVICES}
                                        style={{
                                            width: "100%",

                                            // alignSelf: 'center',
                                        }}

                                        renderItem={({item, index}) => {
                                            let checkUrl = item.URL && item.URL.length > 0;
                                            let url = item.URL && item.URL.length > 0 ? item.URL : null;
                                            let Consumption = Tools.convertByte(item.IN + item.OUT, "return", "G");
                                            let Deducted = Tools.getSizeMG(item.CREDITUSED, null, myService);
                                            return <View
                                                onPress={() => {
                                                    //    alert("xjhbjhfs")
                                                    this.setState({
                                                        itemSelect: item,
                                                        showModal: true
                                                    })

                                                }}
                                                style={{
                                                    width: "100%",

                                                    //  width: '100%',
                                                    //  flex:1,
                                                    // height: typeExport.WIDTH / 3,
                                                    marginBottom: moderateScale(4),
                                                    borderRadius: moderateScale(6),
                                                    borderColor: '#d0d8df',
                                                    backgroundColor: Colors.white,
                                                    borderWidth: moderateScale(1),
                                                    overflow: 'hidden',
                                                    //  marginVertical: moderateScale(2),
                                                    // padding: moderateScale(6)
                                                }}>

                                                <View style={{width: '100%', flexDirection: 'row',}}>

                                                    <TouchableOpacity
                                                        onPress={() => {
                                                            Tools.GoLink(url)
                                                            //NavigationService.navigateParams("WebViewScreen", {item: {external_url: "https://icip.ito.gov.ir/index.php/site/page/view/list_ip",name:item.FNAME}})
                                                        }}
                                                        disabled={!checkUrl}
                                                        style={{
                                                            flex: .4,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            paddingVertical: moderateScale(4)
                                                        }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.FNAME}
                                                            style={[{
                                                                fontSize: moderateScale(12),

                                                                color: url ? Colors.blue : Colors.blackLight,
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                                textAlign: "center",
                                                                marginVertical: moderateScale(2),
                                                                //marginHorizontal: moderateScale(4),

                                                            }, checkUrl ? {
                                                                textDecorationLine: "underline",
                                                                textDecorationStyle: "solid",
                                                                // textDecorationColor: "#000"
                                                            } : {}]}/>
                                                        {
                                                            item.Description && item.Description.length > 0 ?
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={item.Description}
                                                                    style={[{
                                                                        fontSize: moderateScale(10),

                                                                        color: url ? Colors.blue : Colors.blackLight,
                                                                        //  marginTop: moderateScale(4),
                                                                        //  textAlign: "right",
                                                                        textAlign: "center",
                                                                        marginVertical: moderateScale(2),
                                                                        //marginHorizontal: moderateScale(4),

                                                                    }, checkUrl ? {
                                                                        textDecorationLine: "underline",
                                                                        textDecorationStyle: "solid",
                                                                        // textDecorationColor: "#000"
                                                                    } : {}]}/>
                                                                : null
                                                        }

                                                    </TouchableOpacity>


                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>

                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            cammas
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            // text={Tools.convertByte(item.IN  "return", "G")}
                                                            text={Consumption}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.colorDarkText,
                                                                //marginHorizontal: moderateScale(2),
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",


                                                            }}/>

                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            cammas
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            //text={Tools.convertByte(item.OUT, "return", "G")}

                                                            text={index === 0 ? "ندارد" : ((Consumption - Deducted).toFixed(Tools.getToFixed((Consumption - Deducted))))}

                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.red,
                                                                //  marginHorizontal: moderateScale(2),
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            cammas
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            //   text={Tools.convertByte(item.CREDITUSED, "return")}
                                                            text={Tools.getSizeMG(item.CREDITUSED, null, myService)}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.green,
                                                                //  marginHorizontal: moderateScale(2),
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>


                                                </View>


                                            </View>
                                        }}

                                        keyExtractor={(item, index) => index.toString()}
                                        // ListEmptyComponent={() =>
                                        // null}
                                        //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                        // ListFooterComponent={this.renderFooter.bind(this)}
                                        // refreshing={this.props.showRefresh}
                                        // onRefresh={this.handleRefresh.bind(this)}
                                        // onEndReached={this.handleLoadMore.bind(this)}
                                        // initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                    />
                                    {/*       <TouchableOpacity
                                        style={{flexDirection: 'row', alignSelf: 'center'}}
                                        onPress={() => {
                                            NavigationService.navigateParams("ChartSatiaScreen", {
                                                itemAll: this.props.resultsAll,
                                                item: SERVICES,
                                                type: "GroupBarChart",
                                                myService: myService
                                            })
                                        }}
                                    >
                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={"نمودار"}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: Colors.blue,
                                                fontSize: moderateScale(14),
                                            }}/>
                                        <HMIcon
                                            name={I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                            style={{
                                                color: Colors.blue,
                                                fontSize: moderateScale(14),
                                                //  padding: moderateScale(4),
                                                alignSelf: "center",
                                                marginHorizontal: moderateScale(4)
                                            }}/>
                                    </TouchableOpacity>*/}
                                    <View style={{
                                        width: '99%',
                                        height: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.light43,
                                        marginVertical: moderateScale(6)
                                    }}/>
                                    <View
                                        style={{
                                            flex: 1,
                                            paddingHorizontal: moderateScale(2),
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}>
                                        <TouchableOpacity
                                            onPress={() => {
                                                NavigationService.navigateParams("ChartSatiaScreen", {
                                                    itemAll: this.props.resultsAll,
                                                    item: this.props.Credits,
                                                    type: "GroupBarChart"
                                                })
                                            }}
                                            style={{
                                                flex: 1,
                                                marginHorizontal:moderateScale(1),

                                                //width: '96%',

                                                // height: moderateScale(30),
                                                // flexDirection:'row',
                                                //borderRadius: moderateScale(4),

                                                backgroundColor: Colors.colorSecondPrimary,
                                                //margin: moderateScale(4),
                                                alignItems: 'center',
                                                alignSelf: 'center',
                                                paddingVertical: moderateScale(8),
                                                borderRadius: moderateScale(6)
                                                // borderWidth: moderateScale(1),
                                                // borderColor: Colors.colorPrimary,

                                            }}>
                                            <HMTextView text={"نمودار مصرف ماهانه"} type={"bold"}
                                                        style={{
                                                            color: Colors.white,
                                                            //  marginHorizontal: moderateScale(6),
                                                            fontSize: moderateScale(12),
                                                            textAlign: 'center',
                                                            paddingHorizontal: moderateScale(4),
                                                            // marginTop: moderateScale(16),
                                                        }}/>
                                        </TouchableOpacity>

                                        {
                                            SERVICES && SERVICES.length > 0 ?
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        NavigationService.navigateParams("ChartSatiaScreen", {
                                                            itemAll: this.props.resultsAll,
                                                            item: SERVICES,
                                                            type: "GroupBarChart",
                                                            myService: myService,
                                                        })
                                                    }}
                                                    style={{
                                                        flex: 1,
                                                        marginHorizontal:moderateScale(1),

                                                        //width: '96%',

                                                        // height: moderateScale(30),
                                                        // flexDirection:'row',
                                                        //borderRadius: moderateScale(4),

                                                        backgroundColor: Colors.colorSecondPrimary,
                                                        //margin: moderateScale(4),
                                                        alignItems: 'center',
                                                        alignSelf: 'center',
                                                        paddingVertical: moderateScale(8),
                                                        borderRadius: moderateScale(6)
                                                        // borderWidth: moderateScale(1),
                                                        // borderColor: Colors.colorPrimary,

                                                    }}>
                                                    <HMTextView text={"نمودار نوع مصرف"} type={"bold"}
                                                                style={{
                                                                    color: Colors.white,
                                                                    marginHorizontal: moderateScale(6),
                                                                    fontSize: moderateScale(12),
                                                                    textAlign: 'center',
                                                                    paddingHorizontal: moderateScale(4),
                                                                    // marginTop: moderateScale(16),
                                                                }}/>
                                                </TouchableOpacity>
                                                :
                                                null

                                        }


                                        <TouchableOpacity
                                            onPress={() => {

                                                this.setState({
                                                        showCommunications: !this.state.showCommunications,
                                                    },
                                                    () => {
                                                        //  if (this.state.showCommunications)
                                                        if (this.state.selectDate) {

                                                            NavigationService.navigateParams("ShowListMicroConsumptionSatiaScreen", {
                                                                item,
                                                                myService,
                                                                Category,
                                                                Credits,

                                                            })
                                                        }
                                                        else
                                                            this.getData(1, true, () => {
                                                                NavigationService.navigateParams("ShowListMicroConsumptionSatiaScreen", {
                                                                    item,
                                                                    myService,
                                                                    Category,
                                                                    Credits,
                                                                    /*changeCategory: (item, index) => {
                                                                        let arr = []
                                                                        container.props.results.map((obj, index) => {

                                                                                if (obj.sub_service_name == item.FNAME)
                                                                                    arr.push(obj)
                                                                            }
                                                                        )


                                                                        container.setState({
                                                                                indexSelectType: index,
                                                                                itemSelectType: item,
                                                                                // indexSelectType: this.state.indexSelectType == index ? null : index,
                                                                                // itemSelectType: this.state.itemSelectType == index ? null : item,
                                                                                type: item.id,
                                                                                Filter: arr
                                                                            },
                                                                            () => {

                                                                            }
                                                                        )
                                                                    }*/
                                                                })

                                                            })

                                                    })
                                            }}
                                            style={{
                                                flex: 1,
                                                marginHorizontal:moderateScale(1),
                                                //width: '96%',

                                                // height: moderateScale(30),
                                                // flexDirection:'row',
                                                //borderRadius: moderateScale(4),

                                                backgroundColor: Colors.colorSecondPrimary,
                                                //margin: moderateScale(4),
                                                alignItems: 'center',
                                                alignSelf: 'center',
                                                paddingVertical: moderateScale(8),
                                                borderRadius: moderateScale(6)
                                                // borderWidth: moderateScale(1),
                                                // borderColor: Colors.colorPrimary,

                                            }}>
                                            <HMTextView text={"ریز اتصالات"} type={"bold"}
                                                        style={{
                                                            color: Colors.white,
                                                            marginHorizontal: moderateScale(6),
                                                            fontSize: moderateScale(12),
                                                            textAlign: 'center',
                                                            paddingHorizontal: moderateScale(4),
                                                            // marginTop: moderateScale(16),
                                                        }}/>
                                        </TouchableOpacity>
                                    </View>
                                    {

                                        //   this.state.showCommunications ?
                                        1 != 1 ?
                                            <View>
                                                <FlatList
                                                    //   inverted={true}
                                                    keyboardShouldPersistTaps="handled"

                                                    style={{
                                                        //height: moderateScale(40),
                                                        marginTop: moderateScale(4),
                                                        marginBottom: moderateScale(4),

                                                        alignSelf: 'center'
                                                    }}
                                                    //  data={data.results.all_categories}
                                                    //  data={[{id: 1, name: 'متوفی'}, {id: 2, name: 'شعید'}]}
                                                    data={Category}

                                                    renderItem={({item, index}) => {

                                                        return <TouchableOpacity
                                                            onPress={() => {
                                                                let arr = []
                                                                this.props.results.map((obj, index) => {
                                                                     if (obj.sub_service_name == item.FNAME)
                                                                            arr.push(obj)
                                                                    }
                                                                )


                                                                this.setState({
                                                                        indexSelectType: index,
                                                                        itemSelectType: item,
                                                                        // indexSelectType: this.state.indexSelectType == index ? null : index,
                                                                        // itemSelectType: this.state.itemSelectType == index ? null : item,
                                                                        type: item.id,
                                                                        Filter: arr
                                                                    },
                                                                    () => {

                                                                    }
                                                                )
                                                            }
                                                            }
                                                            style={{
                                                                width: (typeExport._WIDTH / 3) - moderateScale(6),
                                                                paddingVertical: moderateScale(4),
                                                                paddingHorizontal: moderateScale(4),
                                                                marginVertical: moderateScale(3),
                                                                backgroundColor: this.state.indexSelectType == index ? Colors.colorPrimary : Colors.white,
                                                                borderColor: this.state.indexSelectType == index ? Colors.white : Colors.colorPrimary,
                                                                borderWidth: moderateScale(1),
                                                                borderRadius: moderateScale(10),
                                                                marginHorizontal: moderateScale(2),
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >

                                                            {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                                                            {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                                                            <HMTextView text={item.FNAME} type={"bold"}
                                                                        style={{
                                                                            color: this.state.indexSelectType == index ? Colors.white : Colors.colorPrimary,
                                                                            marginHorizontal: moderateScale(6),
                                                                            fontSize: moderateScale(11),
                                                                            textAlign: 'center',
                                                                            paddingHorizontal: moderateScale(4)
                                                                        }}/>


                                                        </TouchableOpacity>
                                                    }


                                                    }
                                                    numColumns={3}

                                                    // horizontal={true}
                                                    showsHorizontalScrollIndicator={false}
                                                    keyExtractor={(item, index) => index.toString()}
                                                    //inverted={true}
                                                />
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.colorRow,
                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>
                                                    <View style={{
                                                        flex: .2,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(2)
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"نام سرویس"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .17,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(2)
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"شروع"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .17,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(2)
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"پایان"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .12,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"دریافت"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",

                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .12,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"ارسال"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .12,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"اعتبار مصرفی"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View style={{
                                                        flex: .1,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"سایر"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>

                                                    </View>

                                                </View>
                                                <View style={{
                                                    width: '99%',
                                                    height: moderateScale(1),
                                                    alignSelf: 'center',
                                                    backgroundColor: Colors.light43,
                                                }}/>
                                                {/*<EmptyView empty={this.props.empty}/>*/}

                                                <FlatList
                                                    data={Credits}

                                                    style={{
                                                        width: "100%",

                                                        // alignSelf: 'center',
                                                    }}
                                                    /*        data={
                                                                [
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-7 23:53:04",
                                                                        "logout_time": "1399-6-8 04:14:09",
                                                                        "bytes_in": 77269,
                                                                        "bytes_out": 33536,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "parent_session_id",
                                                                                "81599a0a"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 15665,
                                                                        "retry": 0,
                                                                        "credit_used": 0.4226875305175781
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:48",
                                                                        "logout_time": "1399-6-8 04:22:01",
                                                                        "bytes_in": 0,
                                                                        "bytes_out": 0,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "parent_session_id",
                                                                                "81599b53"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 433,
                                                                        "retry": 0,
                                                                        "credit_used": 0
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:48",
                                                                        "logout_time": "1399-6-8 04:22:01",
                                                                        "bytes_in": 0,
                                                                        "bytes_out": 0,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "parent_session_id",
                                                                                "81599b53"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 433,
                                                                        "retry": 0,
                                                                        "credit_used": 0
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:48",
                                                                        "logout_time": "1399-6-8 04:21:42",
                                                                        "bytes_in": 4710,
                                                                        "bytes_out": 5476,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "pppoe_service",
                                                                                "Pagoli"
                                                                            ],
                                                                            [
                                                                                "mac",
                                                                                "C8:6C:87:66:9F:0C"
                                                                            ],
                                                                            [
                                                                                "nas_port_type",
                                                                                "Ethernet"
                                                                            ],
                                                                            [
                                                                                "terminate_cause",
                                                                                "Lost-Carrier"
                                                                            ],
                                                                            [
                                                                                "port",
                                                                                "PAGOLI"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "RAS-ADSL",
                                                                        "duration": 414,
                                                                        "retry": 0,
                                                                        "credit_used": 0
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:49",
                                                                        "logout_time": "1399-6-8 04:22:01",
                                                                        "bytes_in": 3189,
                                                                        "bytes_out": 896,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [

                                                                                "parent_session_id",
                                                                                "81599b53"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 432,
                                                                        "retry": 0,
                                                                        "credit_used": 0.015583038330078125
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:49",
                                                                        "logout_time": "1399-6-8 04:22:01",
                                                                        "bytes_in": 0,
                                                                        "bytes_out": 0,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "parent_session_id",
                                                                                "81599b53"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 432,
                                                                        "retry": 0,
                                                                        "credit_used": 0
                                                                    },
                                                                    {
                                                                        "user_id": 1758689,
                                                                        "login_time": "1399-6-8 04:14:49",
                                                                        "logout_time": "1399-6-8 04:22:01",
                                                                        "bytes_in": 1467,
                                                                        "bytes_out": 1175,
                                                                        "remote_ip": "2.188.224.95",
                                                                        "details": [
                                                                            [
                                                                                "parent_session_id",
                                                                                "81599b53"
                                                                            ],
                                                                            [
                                                                                "partial",
                                                                                "0"
                                                                            ]
                                                                        ],
                                                                        "ras": "traffic flow",
                                                                        "duration": 432,
                                                                        "retry": 0,
                                                                        "credit_used": 0
                                                                    }
                                                                ]
                                                            }*/
                                                    /*  data={[
                                                          {
                                                              id: 1,
                                                              type: "بین الملل",
                                                              entryTime: "00:12 1399/03/12",
                                                              exitTime: "03:08 1399/03/12",
                                                              duration: "02:55:46",
                                                              download: "73.72",
                                                              upload: "10.72",
                                                              creditReduced: "337.89",
                                                              mac: "4C:5Y:6H:JJ:B6:KT",
                                                              ip: "77.237.88.62",

                                                          },
                                                          {
                                                              id: 1,
                                                              type: "پیام رسان های ایرانی",
                                                              entryTime: "00:12 1399/03/12",
                                                              exitTime: "03:08 1399/03/12",
                                                              duration: "02:55:46",
                                                              download: "0",
                                                              upload: "0",
                                                              creditReduced: "0.0",
                                                              mac: "4C:5Y:6H:JJ:B6:KT",
                                                              ip: "77.237.88.62",

                                                          },
                                                          {
                                                              id: 1,
                                                              type: "سایت های فیلم",
                                                              entryTime: "00:12 1399/03/12",
                                                              exitTime: "03:08 1399/03/12",
                                                              duration: "02:55:46",
                                                              download: "0",
                                                              upload: "0",
                                                              creditReduced: "0.0",
                                                              mac: "4C:5Y:6H:JJ:B6:KT",
                                                              ip: "77.237.88.62",

                                                          },
                                                          {
                                                              id: 1,
                                                              type: "سایت های شرکت",
                                                              entryTime: "00:12 1399/03/12",
                                                              exitTime: "03:08 1399/03/12",
                                                              duration: "02:55:46",
                                                              download: "0.08",
                                                              upload: "0.02",
                                                              creditReduced: "0.0",
                                                              mac: "4C:5Y:6H:JJ:B6:KT",
                                                              ip: "77.237.88.62",

                                                          },
                                                      ]}*/


                                                    renderItem={({item, index}) => {
                                                        return <TouchableOpacity
                                                            onPress={() => {
                                                                //    alert("xjhbjhfs")
                                                                this.setState({
                                                                    itemSelect: item,
                                                                    showModal: true
                                                                })
                                                                //  NavigationService.navigateParams("PaySatiaScreen", {item})

                                                                // duration:"1 ماه",
                                                                //     SubscriptionFee:"200,000 ریال",
                                                                //     SubscriptionFee:210000,
                                                                //     Discount:0,
                                                                //     SumPrice:"45,000 ریال",

                                                            }}
                                                            style={{
                                                                width: "100%",

                                                                //  width: '100%',
                                                                //  flex:1,
                                                                // height: typeExport.WIDTH / 3,
                                                                marginBottom: moderateScale(4),
                                                                borderRadius: moderateScale(6),
                                                                borderColor: '#d0d8df',
                                                                backgroundColor: Colors.white,
                                                                borderWidth: moderateScale(1),
                                                                overflow: 'hidden',
                                                                //  marginVertical: moderateScale(2),
                                                                // padding: moderateScale(6)
                                                            }}>

                                                            <View style={{width: '100%', flexDirection: 'row',}}>
                                                                <View style={{
                                                                    flex: .2,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    paddingVertical: moderateScale(2)
                                                                }}>
                                                                    <HMTextView
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={item.sub_service_name}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //  marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                            //   textAlign: "center",
                                                                            marginVertical: moderateScale(2),
                                                                            //marginHorizontal: moderateScale(4),

                                                                        }}/>
                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .17,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    //   paddingVertical: moderateScale(4)
                                                                }}>
                                                                    <HMTextView
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={item.login_time}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //  marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                            //   textAlign: "center",
                                                                            marginVertical: moderateScale(4),
                                                                            //marginHorizontal: moderateScale(4),

                                                                        }}/>
                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .17,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    //  paddingVertical: moderateScale(4)
                                                                }}>
                                                                    <HMTextView
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={item.logout_time}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //  marginTop: moderateScale(4),
                                                                            //  textAlign: "right",
                                                                            //   textAlign: "center",
                                                                            marginVertical: moderateScale(4),
                                                                            //   marginHorizontal: moderateScale(4),

                                                                        }}/>
                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .12,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>
                                                                    <HMTextView
                                                                        cammas
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={Tools.convertByte(item.bytes_in, "return")}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //marginHorizontal: moderateScale(2),
                                                                            //  marginTop: moderateScale(4),
                                                                            //  textAlign: "right",


                                                                        }}/>

                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .12,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>
                                                                    <HMTextView
                                                                        cammas
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        text={Tools.convertByte(item.bytes_out, "return")}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //  marginHorizontal: moderateScale(2),
                                                                            //  marginTop: moderateScale(4),
                                                                            textAlign: "center",
                                                                        }}/>
                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .12,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}>
                                                                    <HMTextView
                                                                        cammas
                                                                        // numberOfLines={2}
                                                                        type={"bold"}
                                                                        //  text={Tools.convertByte(item.credit_used, "return")}
                                                                        text={Tools.getSizeMG(item.credit_used, "G", myService)}
                                                                        style={{
                                                                            fontSize: moderateScale(10),

                                                                            color: Colors.blackLight,
                                                                            //  marginHorizontal: moderateScale(2),
                                                                            //  marginTop: moderateScale(4),
                                                                            textAlign: "center",
                                                                        }}/>
                                                                </View>
                                                                <View style={{
                                                                    height: '100%',
                                                                    width: moderateScale(1),
                                                                    alignSelf: 'center',
                                                                    backgroundColor: Colors.light43
                                                                }}/>
                                                                <View style={{
                                                                    flex: .1,
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    //  backgroundColor:Colors.colorSecondPrimary
                                                                }}>
                                                                    <HMIcon name={"search"} style={{
                                                                        fontSize: moderateScale(20),
                                                                        color: Colors.blue,
                                                                        marginHorizontal: moderateScale(6),
                                                                        // marginTop: moderateScale(3)
                                                                    }}/>
                                                                    {/*    <HMTextView
                                                            cammas
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            //  text={i18n.t('constant.Buy')}
                                                            text={"مشاهده"}
                                                            style={{
                                                                fontSize: moderateScale(10),

                                                                color: Colors.blue,
                                                                // marginHorizontal: moderateScale(2),
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>*/}
                                                                </View>

                                                            </View>


                                                        </TouchableOpacity>
                                                    }}
                                                    /*
                                                                                    renderItem={({item, index}) => {

                                                                                        let count = item.details ? item.details.length : 0;
                                                                                        let Mac = "";
                                                                                        for (let i = 0; i < count; i++) {
                                                                                            let countChild = item.details[i] ? item.details[i].length : 0;
                                                                                            for (let ii = 0; ii < count; ii++) {
                                                                                                let checkMac = item.details[i][ii] == "mac";

                                                                                                if (checkMac) {
                                                                                                    Mac = item.details[i][ii + 1]
                                                                                                }

                                                                                            }
                                                                                        }
                                                    //let Mac=item.details.find(obj=>obj.mac==)

                                                                                        return <View
                                                                                            style={{
                                                                                                flex: 1,
                                                                                                overflow: 'hidden',
                                                                                                //height:  moderateScale(100),
                                                                                                // padding: moderateScale(4),
                                                                                                margin: moderateScale(5),
                                                                                                borderWidth: moderateScale(1),
                                                                                                borderRadius: moderateScale(2),
                                                                                                borderColor: '#ddd',
                                                                                                borderBottomWidth: 0,
                                                                                                shadowColor: '#000',
                                                                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                                                shadowOpacity: 0.6,
                                                                                                shadowRadius: moderateScale(2),
                                                                                                elevation: moderateScale(1),
                                                                                                // marginLeft: moderateScale(1),
                                                                                                // marginRight: moderateScale(1),
                                                                                                // marginTop: moderateScale(1),
                                                                                                // marginBottom: moderateScale(1),
                                                                                                backgroundColor: item.background_color ? item.background_color : Colors.white,
                                                                                            }}>
                                                                                            {/!*1*!/}
                                                                                            <View
                                                                                                style={{
                                                                                                    width: typeExport._WIDTH - moderateScale(12),
                                                                                                    backgroundColor: Colors.ColorLine,
                                                                                                    flexDirection: 'row',
                                                                                                    ////justifyContent: "space-between",
                                                                                                    padding: moderateScale(6)
                                                                                                }}>
                                                                                                <HMTextView
                                                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                    text={"نوع" + " : "}
                                                                                                    type={"bold"}
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        color: Colors.blackLight,
                                                                                                        fontSize: moderateScale(11),


                                                                                                    }}/>

                                                                                                <HMTextView
                                                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                    text={item.type}
                                                                                                    type={"bold"}
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        color: Colors.colorDark,
                                                                                                        fontSize: moderateScale(10),


                                                                                                    }}/>

                                                                                            </View>
                                                                                            <View
                                                                                                style={{
                                                                                                    width: typeExport._WIDTH - moderateScale(12),
                                                                                                    backgroundColor: Colors.white,
                                                                                                    flexDirection: 'row',
                                                                                                    //justifyContent: "space-between",
                                                                                                    padding: moderateScale(6)
                                                                                                }}>
                                                                                                <View style={{
                                                                                                    //  justifyContent: "space-between",
                                                                                                    flex: 1,
                                                                                                    flexDirection: 'row'
                                                                                                }}>
                                                                                                    <View style={{flexDirection: 'row', flex: .32,}}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"ورود" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={item.login_time}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>

                                                                                                    </View>
                                                                                                    <View style={{
                                                                                                        flexDirection: 'row',
                                                                                                        flex: .32,
                                                                                                        marginHorizontal: moderateScale(8)
                                                                                                    }}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"خروج" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={item.logout_time}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>
                                                                                                    </View>
                                                                                                    <View style={{flexDirection: 'row', flex: .32,}}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"مدت زمان" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={Tools.getAudioTimeString(item.duration)}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>
                                                                                                    </View>

                                                                                                </View>

                                                                                            </View>
                                                                                            {/!*3*!/}
                                                                                            <View
                                                                                                style={{
                                                                                                    width: typeExport._WIDTH - moderateScale(12),
                                                                                                    backgroundColor: Colors.ColorLine,
                                                                                                    flexDirection: 'row',
                                                                                                    //justifyContent: "space-between",
                                                                                                    padding: moderateScale(6)
                                                                                                }}>
                                                                                                <View style={{
                                                                                                    // justifyContent: "space-between",
                                                                                                    flex: 1,
                                                                                                    flexDirection: 'row'
                                                                                                }}>
                                                                                                    <View style={{flexDirection: 'row', flex: .32,}}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"دریافتی" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={Tools.convertByte(item.bytes_in, "return")}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>

                                                                                                    </View>
                                                                                                    <View style={{
                                                                                                        flexDirection: 'row',
                                                                                                        flex: .32,
                                                                                                        marginHorizontal: moderateScale(8)
                                                                                                    }}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"ارسالی" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={Tools.convertByte(item.bytes_out, "return")}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>
                                                                                                    </View>
                                                                                                    <View style={{flexDirection: 'row', flex: .32,}}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={"اعتبار مصرفی(M)" + " : "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={Number((item.credit_used).toFixed(2))}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>
                                                                                                    </View>

                                                                                                </View>

                                                                                            </View>
                                                                                            {/!*4*!/}
                                                                                            <View
                                                                                                style={{
                                                                                                    width: typeExport._WIDTH - moderateScale(12),
                                                                                                    backgroundColor: Colors.white,
                                                                                                    flexDirection: 'row',
                                                                                                    //justifyContent: "space-between",
                                                                                                    padding: moderateScale(6)
                                                                                                }}>
                                                                                                <View style={{
                                                                                                    // justifyContent: "space-between",
                                                                                                    flex: 1,
                                                                                                    flexDirection: 'row'
                                                                                                }}>
                                                                                                    <View style={{flexDirection: 'row', flex: .32,}}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={" : " + "Mac"}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={Mac && Mac.length > 0 ? Mac : " - "}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(9),


                                                                                                            }}/>

                                                                                                    </View>
                                                                                                    <View style={{
                                                                                                        flexDirection: 'row',
                                                                                                        flex: .32,
                                                                                                        marginHorizontal: moderateScale(8)
                                                                                                    }}>
                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={" : " + "ip"}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.blackLight,
                                                                                                                fontSize: moderateScale(11),


                                                                                                            }}/>

                                                                                                        <HMTextView
                                                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                                            text={item.remote_ip}
                                                                                                            type={"bold"}
                                                                                                            style={{
                                                                                                                textAlign: "center",
                                                                                                                color: Colors.colorDark,
                                                                                                                fontSize: moderateScale(10),


                                                                                                            }}/>
                                                                                                    </View>


                                                                                                </View>

                                                                                            </View>


                                                                                        </View>
                                                                                    }}
                                                    */

                                                    // renderItem={this.renderItem}
                                                    keyExtractor={(item, index) => index.toString()}
                                                    ListEmptyComponent={() =>
                                                        null}
                                                    //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                                    ListFooterComponent={this.renderFooter.bind(this)}
                                                    refreshing={this.props.showRefresh}
                                                    onRefresh={this.handleRefresh.bind(this)}
                                                    onEndReached={this.handleLoadMore.bind(this)}
                                                    initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                                />
                                            </View>
                                            :
                                            null
                                    }


                                    {/*     <HMModal
                                visibleModal={this.state.visibleModal === 'Modal'}
                                hiddenModal={() => this.hiddenModal()}
                                textInput={this.state["text" + this.state.indexFilter]}
                                SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                //textInput={this.state.mobile}
                                dataSource={this.state["dataSource" + this.state.indexFilter]}
                                // onChange={() => this.onChangeCondition(index, item)}
                                onChangeItem={this.onChange}
                            />*/}

                                    {/*   <TouchableOpacity
                                onPress={() => {
                                    this.setState({
                                        showDialogDate: true
                                    })
                                }}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    overflow: 'hidden',
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                    borderRadius: moderateScale(24),
                                    // padding: moderateScale(4),
                                    margin: moderateScale(5),
                                    borderWidth: moderateScale(1),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    // marginLeft: moderateScale(1),
                                    // marginRight: moderateScale(1),
                                    // marginTop: moderateScale(1),
                                    // marginBottom: moderateScale(1),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: "center"
                                }}>
                                <HMIcon type={"FontAwesome"} name="calendar" style={{
                                    color: Colors.white,
                                    fontSize: moderateScale(24),
                                    padding: moderateScale(4),
                                    alignSelf: "center",
                                }}/>
                            </TouchableOpacity>*/}

                                </View>
                            </ScrollView>

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        onPress={() => this.getData(this.props.page)}/> : null
                            }
                            {
                                this.state.showDialogDate ?
                                    <HMDialogSelectDate
                                        DateTo={this.state.DateTo}
                                        DateFrom={this.state.DateFrom}
                                        onPressOk={this.setDate}
                                        onPressCancel={() => {
                                            this.setState({
                                                showDialogDate: false
                                            })
                                        }}
                                    />

                                    :

                                    null
                            }

                            {

                                 this.ModalDetails()

                            }
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    setDate(DateFrom, DateTo) {

        container.setState({
                DateFrom, DateTo, selectDate: true, showDialogDate: false,
                // indexSelectType: container.state.indexSelectTypePrevious,

            },
            () => {
                container.getData(1)
            }
        )
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>
                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: '',
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: '',
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(11),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
          ///  ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListMicroConsumptionSatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListMicroConsumptionSatiaScreen, 'POST', 1)
    }

    renderFooterCredit() {
        return this.props.isLoading || this.props.showRefresh ?
            <ActivityIndicator color={Colors.colorPrimary} size={"large"}/> : null
    }

    renderFooter() {

        if (this.props.failed === false) {
            //log("renderFooter", this.props)
            // return this.props.lazyload_end ? null : <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
            return (this.props.lazyload_end === true || this.props.page === 1) ? null :

                this.props.showLoading || this.props.showRefresh === true ?
                    <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>
                    :
                    <HMButton
                        text="بیشتر"
                        style={styles.buttonModalStyle}
                        onPress={() => this.getData(this.props.page)}
                        //  onPress={() => alert("")}
                    />
        } else {

            return (
                <HMButton
                    buttonText="تلاش مجدد"
                    containerStyle={styles.buttonModalStyle}
                    onPress={() => this.getData(this.props.page)}
                />
            );
        }
    }

    /*  renderFooter() {

          if (this.props.failed === false) {
              return this.props.lazyload_end || this.props.page === 0 ? null :

                  <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


          } else {
              return (
                  <Button
                      buttonText={i18n.t('constant.retry')}
                      containerStyle={styles.buttonModalStyle}
                      onPress={() =>
                          this.getData(this.props.page)
                      }

                  />
              );
          }
      }*/
    handleLoadMore() {
        // if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
        //     // this.props.callService(urlListMicroConsumptionSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListMicroConsumptionSatiaScreen, 'POST', this.props.page)
        //     if (this.props.page === 0)
        //         this.getData(1)
        //     else
        //         this.getData(this.props.page)
        // }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        //alert("hydfg")
        container.setState({
                visibleModal: '',
                showModal: false,
                typeModal: ""
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }


    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

    ModalDetails() {
        let count = 0;
        let Mac = "";
        let item = this.state.itemSelect ? this.state.itemSelect : {}


        if (this.state.itemSelect) {
            count = item.details ? item.details.length : 0;

            for (let i = 0; i < count; i++) {
                let countChild = item.details[i] ? item.details[i].length : 0;
                for (let ii = 0; ii < count; ii++) {
                    let checkMac = item.details[i][ii] == "mac";

                    if (checkMac) {
                        Mac = item.details[i][ii + 1]
                    }

                }
            }
        }


        return (
            <HMModal
                // style={{backgroundColor: Colors.transparent}}
                // position={"center"}
                // ref={"modal"}
                // backdropPressToClose={true}
                // coverScreen={true}
                // swipeToClose={true}
                // backButtonClose={true}
                // isOpen={this.state.showModal}
                // onClosed={() => this.setState({showModal: false})}
                // onBackdropPress={() => this.hiddenModal()}
                // onBackButtonPress={() => this.hiddenModal()}


                isVisible={this.state.showModal}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}



            >

                {
                    this.state.typeModal == "help" ?
                        <View
                            style={{
                            //    width: '96%',
                             //   height: '100%',
                                alignSelf: 'center',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                            <View
                                style={{
                                    backgroundColor: Colors.colorSecondPrimary,

                                    width: '100%',
                                    //   height: '100%',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    paddingHorizontal: moderateScale(8),
                                    paddingVertical: moderateScale(8),
                                }}>

                                <FlatList
                                    data={[
                                        {
                                            name: 'مشترک گرامی',
                                            description: 'در شبکه ساتیا، ترافیک داخل ایران 75 درصد تخفیف دارد و 165 سایت اعم از شاد و ساتیا و دانشگاهها رایگان هست بنابراین معمولا ترافیک تبادل شده از اعتبار کسر شده کمتر می باشد'
                                        },
                                        {
                                            name: 'ترافیک تبادل شده',
                                            description: 'یعنی میزان  تبادل مودم شما با شبکه ساتیا که شامل تمامی سرویس ها اعم از اینترنت بین الملل، سایتهای داخلی و سایتهای رایگان و ... می باشد'
                                        },
                                        {
                                            name: 'اعتبار کسر شده',
                                            description: 'یعنی میزان اعتبار کسر شده از ترافیک خریداری شده  مثلا شما 4 گیگ از سایت داخلی دانلود کنید  از اعتبار بسته شما به میزان 1 گیگ اینترنت بین الملل کسر می شود'
                                        },
                                    ]}

                                    style={{
                                        width: "100%",

                                        // alignSelf: 'center',
                                    }}
                                    renderItem={({item, index}) => {
                                        let checkUrl = item.URL && item.URL.length > 0;
                                        let url = item.URL && item.URL.length > 0 ? item.URL : null;
                                        return <View

                                            style={{
                                                width: "100%",

                                                //  width: '100%',
                                                //  flex:1,
                                                // height: typeExport.WIDTH / 3,
                                                marginBottom: moderateScale(4),
                                                borderRadius: moderateScale(6),
                                                //  borderColor: '#d0d8df',
                                                // backgroundColor: Colors.white,
                                                //  borderWidth: moderateScale(1),
                                                overflow: 'hidden',
                                                marginVertical: moderateScale(12),
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>

                                            <View style={{
                                                width: '100%',
                                                // flexDirection: 'row',
                                                marginVertical: moderateScale(2)
                                            }}>

                                                <HMTextView
                                                    cammas
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={item.name}
                                                    style={{
                                                        fontSize: moderateScale(16),

                                                        color: Colors.white,
                                                        //  marginHorizontal: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //textAlign: "center",
                                                    }}/>

                                                <HMTextView
                                                    cammas
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={item.description}
                                                    style={{
                                                        fontSize: moderateScale(12),

                                                        color: Colors.white,
                                                        //  marginHorizontal: moderateScale(2),
                                                        //  marginTop: moderateScale(4),
                                                        //  textAlign: "center",
                                                    }}/>


                                            </View>


                                        </View>
                                    }}

                                    keyExtractor={(item, index) => index.toString()}
                                    ListEmptyComponent={() =>
                                        null}
                                    // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                    // ListFooterComponent={this.renderFooterCredit.bind(this)}
                                    // refreshing={this.props.showRefresh}
                                    // onRefresh={this.handleRefresh.bind(this)}
                                    //onEndReached={this.handleLoadMore.bind(this)}
                                    // initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                />

                            </View>
                        </View>
                        :
                        <View
                            style={{
                              //  width: '100%',
                               // height: '100%',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>

                            <View style={{

                                //  justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: Colors.white,
                                // margin: moderateScale(16),
                                alignSelf: 'center',

                                // height:typeExport._WIDTH/2.7
                            }}>
                                <HMTextView
                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                    text={"جزئیات"}
                                    type={"bold"}
                                    style={{
                                        textAlign: "center",
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),


                                    }}/>
                                {
                                    this.state.itemSelect ?
                                        <View
                                            style={{
                                                // flex: 1,
                                                overflow: 'hidden',
                                                //height:  moderateScale(100),
                                                // padding: moderateScale(4),
                                                //  margin: moderateScale(20),
                                                borderWidth: moderateScale(1),
                                                borderRadius: moderateScale(2),
                                                borderColor: '#ddd',
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: item.background_color ? item.background_color : Colors.white,
                                            }}>

                                            {/*      <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.ColorLine,
                                            flexDirection: 'row',
                                            ////justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={"نوع" + " : "}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: Colors.blackLight,
                                                fontSize: moderateScale(11),


                                            }}/>

                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={item.sub_service_name}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: Colors.colorDark,
                                                fontSize: moderateScale(10),


                                            }}/>

                                    </View>
                                    <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.white,
                                            flexDirection: 'row',
                                            //justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <View style={{
                                            // justifyContent: "space-between",
                                            flex: 1,
                                            flexDirection: 'row'
                                        }}>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"ورود" + " : "}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(11),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.login_time}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(10),


                                                }}/>
                                        </View>

                                    </View>
                                    <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.ColorLine,
                                            flexDirection: 'row',
                                            //justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <View style={{
                                            // justifyContent: "space-between",
                                            flex: 1,
                                            flexDirection: 'row'
                                        }}>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"خروج" + " : "}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(11),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={item.logout_time}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(10),


                                                }}/>

                                        </View>

                                    </View>*/}

                                            <View
                                                style={{
                                                    width: typeExport._WIDTH - moderateScale(12),
                                                    backgroundColor: Colors.ColorLine,
                                                    flexDirection: 'row',
                                                    //justifyContent: "space-between",
                                                    padding: moderateScale(6)
                                                }}>
                                                <View style={{
                                                    // justifyContent: "space-between",
                                                    flex: 1,
                                                    flexDirection: 'row'
                                                }}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={"مدت زمان" + " : "}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}/>

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={Tools.getAudioTimeString(item.duration)}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(10),


                                                        }}/>

                                                </View>

                                            </View>
                                            {/*  <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.ColorLine,
                                            flexDirection: 'row',
                                            //justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <View style={{
                                            // justifyContent: "space-between",
                                            flex: 1,
                                            flexDirection: 'row'
                                        }}>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"دریافتی" + " : "}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(11),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={Tools.convertByte(item.bytes_in, "return")}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(10),


                                                }}/>

                                        </View>

                                    </View>
                                    <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.white,
                                            flexDirection: 'row',
                                            //justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <View style={{
                                            // justifyContent: "space-between",
                                            flex: 1,
                                            flexDirection: 'row'
                                        }}>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"ارسالی" + " : "}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(11),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={Tools.convertByte(item.bytes_out, "return")}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(10),


                                                }}/>

                                        </View>

                                    </View>
                                    <View
                                        style={{
                                            width: typeExport._WIDTH - moderateScale(12),
                                            backgroundColor: Colors.ColorLine,
                                            flexDirection: 'row',
                                            //justifyContent: "space-between",
                                            padding: moderateScale(6)
                                        }}>
                                        <View style={{
                                            // justifyContent: "space-between",
                                            flex: 1,
                                            flexDirection: 'row'
                                        }}>
                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={"اعتبار مصرفی(M)" + " : "}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.blackLight,
                                                    fontSize: moderateScale(11),


                                                }}/>

                                            <HMTextView
                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                text={Number((item.credit_used).toFixed(2))}
                                                type={"bold"}
                                                style={{
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(10),


                                                }}/>

                                        </View>

                                    </View>*/}
                                            <View
                                                style={{
                                                    width: typeExport._WIDTH - moderateScale(12),
                                                    backgroundColor: Colors.white,
                                                    flexDirection: 'row',
                                                    //justifyContent: "space-between",
                                                    padding: moderateScale(6)
                                                }}>
                                                <View style={{
                                                    // justifyContent: "space-between",
                                                    flex: 1,
                                                    flexDirection: 'row'
                                                }}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={" : " + "Mac"}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}/>

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={Mac && Mac.length > 0 ? Mac : " - "}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(9),


                                                        }}/>

                                                </View>

                                            </View>
                                            <View
                                                style={{
                                                    width: typeExport._WIDTH - moderateScale(12),
                                                    backgroundColor: Colors.ColorLine,
                                                    flexDirection: 'row',
                                                    //justifyContent: "space-between",
                                                    padding: moderateScale(6)
                                                }}>
                                                <View style={{
                                                    // justifyContent: "space-between",
                                                    flex: 1,
                                                    flexDirection: 'row'
                                                }}>

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={" : " + "ip"}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}/>

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.remote_ip}
                                                        type={"bold"}
                                                        style={{
                                                            textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(10),


                                                        }}/>
                                                </View>

                                            </View>


                                        </View>
                                        :
                                        null
                                }


                            </View>


                        </View>
                }

            </HMModal>
        );
    }
}

